<template>
	<!-- begin #footer -->
	<div id="footer" class="footer" style="border-top: 0">
		<!-- &copy; 2021 AHM OIL, All Rights Reserved -->
	</div>
	<!-- end #footer -->
</template>

<script>
import PageOptions from '@/Options/PageOptions.js'

export default {
  name: 'Footer',
  data() {
		return {
			pageOptions: PageOptions
		}
  }
}
</script>
